import { useId } from 'react'
import { observer } from 'mobx-react-lite'
import { Form, FormColumn, FormColumns, FormRow } from '@/components/Form'
import { NumericInputContainer } from '@/components/inputs/NumericInputContainer'
import { BulkApplyDiscountDialog } from '@/features/admin/bundle/BulkApplyDiscountDialog'
import { type BulkApplyDiscountDialogViewModel } from './BulkApplyDiscountDialogViewModel'

export interface BulkApplyDiscountDialogContainerProps {
  vm: BulkApplyDiscountDialogViewModel
}

export const BulkApplyDiscountDialogContainer = observer(
  function BulkApplyDiscountDialogContainer({
    vm,
  }: BulkApplyDiscountDialogContainerProps) {
    const testId = 'bulk-apply-discount'
    const formId = useId()

    return (
      <BulkApplyDiscountDialog
        showing={vm.modal.showing}
        onClose={vm.modal.close}
        previews={vm.previews.map((preview) => ({
          id: preview.bundle.id,
          name: preview.bundle.name,
          currentPrice: preview.currentPrice,
          newPrice: preview.newPrice,
        }))}
        hasDiscount={vm.hasDiscount}
        negativePriceWarning={vm.negativePriceWarning}
        hasEligibleBundles={vm.hasEligibleBundles}
        hasArchivedBundles={vm.hasArchivedBundles}
        archivedCount={vm.archivedCount}
        canApply={vm.canApply}
        isSubmitPending={vm.submit.pending}
        formId={formId}
        testId={testId}
      >
        <Form id={formId} onSubmit={vm.submit}>
          <FormRow>
            <FormColumns>
              <FormColumn>
                <NumericInputContainer
                  autoFocus
                  mode="live"
                  precision={0}
                  placeholder="0"
                  label="Discount percentage"
                  field="percentOff"
                  model={vm}
                  error={vm.validation.getError('percentOff')}
                  testId={`${testId}-percent-input`}
                  help="Applied to each bundle's current price. Service item prices are not affected."
                />
              </FormColumn>
            </FormColumns>
          </FormRow>
        </Form>
      </BulkApplyDiscountDialog>
    )
  },
)
